export default "__VITE_ASSET__CxWHlHBB__"